module.exports = __webpack_public_path__ + "img/Shark.86adfc97.png";